import React from 'react'
import PropTypes from 'prop-types'

import { Text } from '../forms'
import { useMutation } from '../graphql'


const FakeInput = props => {
	const {
		Component = Text,
		path,
		fieldName = 'caption',
		additionalFields = {},
		query,
		rawCreateRequest,
		createRequest,
		then = (result) => {},
		...rest
	} = props
	const [defaultCreateRequest] = useMutation(rawCreateRequest)
	const handleBlur = event => {
		const value = event.target.value
		if(value) {
			if(createRequest) {
				return createRequest({ [fieldName]: value, ...additionalFields })
			}
			return defaultCreateRequest({
				variables: {
					fields: {
						[fieldName]: value,
						...additionalFields
					}
				},
				refetchQueries: [{ query }],
				awaitRefetchQueries: true
			}).then(result=>{
				then(result)
			})
		}
	}
	return (
		<Component
			onBlur={handleBlur}
			field={`path[${fieldName}]`}
			{...rest}
		/>
	)
}


FakeInput.propTypes = {
	// Component: PropTypes.element,
	rawCreateRequest: PropTypes.object,
	then: PropTypes.func,
	fieldName: PropTypes.string,
	additionalFields: PropTypes.object,
	query: PropTypes.object
}


export default FakeInput

